import React, { useEffect, useState } from "react";
import { Row, Form, Tab, Tabs, Col, Container, Collapse, Alert, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getApi, patchOrder } from "../../../actions/structure.action";
import { useDialog } from "../../../helpers/useDialog";
import isEmpty from "../../../utils/is-Empty";
import PageSpinner from "../../common/PageSpinner";
import CustomTable from "../common/CustomTable";
import CustomButton from "../../common/CustomButton";
import CustomModalWrap from "../../common/CustomModalWrap";
import { CloseIcon } from "../../../assets/svg/svg-icons";
import DashbordOrder from "../common/DashbordOrder/indes";
import { tableStructures } from "../../../helpers/table-structures";
import { toast } from "react-toastify";
import moment from "moment";
import { stringConstants } from "../../../helpers";
import axios from "axios";
import { BHAREE_BASE_URL_LOCAL } from "../../../config/config.url";

const Dashboard = ({ notificationOrderId }) => {
  const dispatch = useDispatch();
  const { alert, confirm, DialogModal } = useDialog();
  const [shippedOrders, setShippedOrders] = useState([]);
  const [lpAcceptedOrders, setLPAcceptedOrders] = useState([]);
  const [outForDeliveryOrders, setOutForDeliveryOrders] = useState([]);
  const [outForDeliveryOrdersVehicleWise, setOutForDeliveryOrdersVehicleWise] = useState({});
  const [deliveredOrders, setDeliveredOrders] = useState([]);
  const [deliveredOrdersVehicleWise, setDeliveredOrdersVehicleWise] = useState({});
  const [loading, setLoading] = useState(false);
  const [isOrderOpen, setIsOrderOpen] = useState(true); // Collapsed/expanded state for orders
  const [isLPAcceptedOpen, setIsLPAcceptedOpen] = useState(true); // Collapsed/expanded state for orders
  const [isOutForDeliveryOpen, setIsOutForDeliveryOpen] = useState(true); // Collapsed/expanded state for out for delivery orders
  const [isDeliveredOpen, setIsDeliveredOpen] = useState(true); // Collapsed/expanded state for delivered orders
  const [showOrderModal, setOrderModal] = useState(false);
  const [currentOrderId, setCurrentOrderId] = useState("");
  const [topMessage, setTopMessage] = useState([]);
  const [userObj, setUserObj] = useState({});

  const { auth, orders, checkEmailVerified, vehicleLoadStatistics } = useSelector((state) => {
    return state;
  });

  const dispatchObj = {
    type: stringConstants.SET_CURRENT_VIEW,
    payload: stringConstants.DASHBOAD,
  };

  const groupByVehicle = (orders = []) => {
    return orders.reduce((acc, order) => {
      const vehicleNo = order.vehicleNumber || "UNASSIGNED";

      if (!acc[vehicleNo]) {
        acc[vehicleNo] = [];
      }

      acc[vehicleNo].push(order);
      return acc;
    }, {});
  };

  useEffect(() => {
    getApi("getBhreeAdminBasicTables", dispatch);
    getApi("getOrders", dispatch);
    getApi("checkEmailVerified", dispatch);
    getLPDetails();
  }, [dispatch]);

  useEffect(() => {
    if (
      auth &&
      auth?.user?.id &&
      auth?.user?.role?.role_name === stringConstants.LOGISTIC_PARTNER
    ) {
      getApi("getVehicleLoadStatistics", dispatch, auth?.user?.id).then((res) => {
        // console.log("Vehicle Load Statistics: ", res);
      });
    }
  }, [auth]);

  useEffect(() => {
    if (!isEmpty(orders?.data) && orders?.data.length > 0) {
      const tempShippedOrders = orders?.data.filter((item) => item.status === "shipped");
      setShippedOrders(tempShippedOrders);

      const tempLPAcceptedOrders = orders?.data.filter((item) => item.status === "lpaccepted");
      setLPAcceptedOrders(tempLPAcceptedOrders);

      const tempOutForDeliveryOrders = orders?.data.filter(
        (item) => item.status === "outfordelivery",
      );
      setOutForDeliveryOrders(tempOutForDeliveryOrders);
      setOutForDeliveryOrdersVehicleWise(groupByVehicle(tempOutForDeliveryOrders));

      const tempDeliveredOrders = orders?.data.filter((item) => item.status === "delivered");
      setDeliveredOrders(tempDeliveredOrders);
      setDeliveredOrdersVehicleWise(groupByVehicle(tempDeliveredOrders));
    }
  }, [orders]);

  useEffect(() => {
    setTopMessage([]);
    let mMessages = [];

    if (!isEmpty(checkEmailVerified?.data) && checkEmailVerified?.data?.email_verify_status === 0) {
      mMessages.push(
        <>Your email is not verified. Please {clickHereToVerify()} to verify your email address.</>,
      );
    }

    setTopMessage(mMessages);
  }, [auth, checkEmailVerified]);

  useEffect(() => {
    if (!isEmpty(notificationOrderId)) {
      setCurrentOrderId(notificationOrderId);
      orderViewToggle();
    }
  }, [notificationOrderId]);

  const getLPDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(BHAREE_BASE_URL_LOCAL + "/logistics/" + auth?.user?.id, {
        headers: {
          Authorization: `Bearer ${localStorage.jwtToken}`,
        },
      });
      // console.log("getLPDetails: ", response);
      if (response && response?.data) {
        if (response?.data?.success) {
          setUserObj(response?.data?.data);
        }
      }
      return response;
    } catch (error) {
      console.error("Upload error:", error.response || error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const changeToDelivered = async (data) => {
    try {
      if (data?.payment_status_id !== "success") {
        alert(
          "Payment not completed. Cannot mark order as delivered. Please click on 'View' to check payment details and ask the customer to complete the payment. You can generate the payment link or show the QR code to the customer for completing the payment.",
        );
        return;
      }

      let sendObj = {};
      sendObj["id"] = data.id;
      sendObj["status"] = "delivered";

      const response = await patchOrder(sendObj, dispatch, dispatchObj);
      console.log("Change Delivered: ", response);
      if (response && response?.success) {
        getLPDetails();
      }
    } catch (err) {
      console.error("Failed to mark delivered:", err);
      toast.error("Failed to mark delivered.");
    }
  };

  const clickHereToVerify = () => {
    return (
      <Link
        variant="link"
        className="m-0 p-0"
        onClick={() => {
          setLoading(true);
          getApi("sendEmailVerificationLink", dispatch)
            .then((res) => {
              if (res?.rawData?.success) {
                toast.success("Verification link has been sent to your email address.");
              } else {
                toast.error("Failed to send verification link. Please try again.");
              }
            })
            .catch((err) => {
              toast.error("Failed to send verification link. Please try again.");
            })
            .finally(() => {
              setLoading(false);
            });
        }}
      >
        click here
      </Link>
    );
  };

  const orderViewToggle = () => setOrderModal(!showOrderModal);
  const OrderDetailsModal = () => {
    return (
      <CustomModalWrap
        className="modal-custom-class order-popup"
        hedaerContent={
          <>
            <h4>{"Order"}</h4>
            <p
              onClick={() => {
                orderViewToggle();
              }}
            >
              <CloseIcon />
            </p>
          </>
        }
        buttonClasses={"action-button  hidden"}
        buttonContant={"view"}
        isModalOpen={showOrderModal}
        showModal={orderViewToggle}
        closeModal={orderViewToggle}
      >
        <DashbordOrder
          id={currentOrderId}
          closeModal={orderViewToggle}
          isModalOpen={showOrderModal}
          dispatchObj={dispatchObj}
          getLPDetails={getLPDetails}
        />
      </CustomModalWrap>
    );
  };

  const onAvailableChange = async (userId) => {
    console.log("handleAvailableChange: userId: ", userId);
    setLoading(true);
    try {
      const response = await axios.get(
        `${BHAREE_BASE_URL_LOCAL}/logistics/changeAvailableStatus/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.jwtToken} `,
          },
        },
      );

      if (response && response?.data) {
        if (response?.data?.success) {
          getLPDetails();
        }
      }
    } catch (error) {
      console.error("Upload error:", error.response || error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="px-3 py-2">
      {DialogModal}
      {loading && <PageSpinner />}
      <Row className="mx-0 p-0 mb-2">
        <Col md={6} className="m-0 p-0">
          <h1 className="p-0 title text-uppercase">{"Dashboard"}</h1>
        </Col>
        <Col md={6} className="m-0 p-0">
          <div className="d-flex justify-content-end mx-2">
            <span className="me-2 fw-bold">
              Available:{" "}
              {userObj?.business_info?.is_available ? (
                <span className="text-success">✅ Yes</span>
              ) : (
                <span className="text-danger">❌ No</span>
              )}
            </span>
            <Form.Check
              className="large-switch"
              type="switch"
              id={`available-check-user`}
              checked={userObj?.business_info?.is_available}
              onChange={(e) => onAvailableChange(userObj.id)}
            />
            <span className="me-2 fw-bold" style={{ marginLeft: "30px" }}>
              Vehicle (Main):{" "}
              {userObj?.vehicle_is_busy ? (
                <span className="text-danger">❌ Busy. In Transit.</span>
              ) : (
                <span className="text-success">✅ Free</span>
              )}
            </span>
          </div>
        </Col>
      </Row>
      {!loading && !isEmpty(topMessage) && (
        <Row className="mx-0 p-0 mb-3">
          <Alert variant="danger" className="mb-0">
            <ul className="m-0 p-0 list-unstyled">
              {topMessage.map((msg, index) => (
                <li key={index} className="d-flex align-items-start">
                  <span className="me-2 text-danger">✔</span>
                  <span>{msg}</span>
                </li>
              ))}
            </ul>
          </Alert>
        </Row>
      )}
      {OrderDetailsModal()}

      {vehicleLoadStatistics && vehicleLoadStatistics?.data?.length > 0 && (
        <Row className="section-row mb-4 no-records px-1">
          <h4 className="m-0">Current Vehicle Load Statistics</h4>
          {/* Display vehicle load statistics here card wise */}
          <Row className="g-3 mt-0">
            {vehicleLoadStatistics.data.map((statistic, index) => (
              <Col md={3} key={index}>
                <div className="statistic-card p-3 border rounded">
                  <h5 className="mb-2">
                    🚚 {statistic.vehicleInfo?.vehicle_reg_no}
                    {statistic.mainVehicle ? " (Main)" : ""}
                  </h5>
                  <hr className="m-0" />
                  <p className="small text-primary mt-2 mb-2">
                    {statistic?.isOverloaded ? (
                      <i className="bi bi-circle-fill text-danger"></i>
                    ) : (
                      <i className="bi bi-circle-fill text-success"></i>
                    )}{" "}
                    Max Payload: {statistic.vehicleInfo?.vehicle_payload_capacity} kg
                  </p>
                  <div className="d-flex flex-column">
                    <h6 className="d-flex justify-content-between mb-2">
                      <span>Assigned Load:</span> <span>{statistic.shippedLoad} kg</span>
                    </h6>
                    <h6 className="d-flex justify-content-between mb-2">
                      <span>Accepted Load:</span> <span>{statistic.lpAcceptedLoad} kg</span>
                    </h6>
                    <h6 className="d-flex justify-content-between mb-2">
                      <span>Out for Delivery Load:</span>{" "}
                      <span>{statistic.outForDeliveryLoad} kg</span>
                    </h6>
                    <h6 className="d-flex flex-column">
                      <span className="fw-bold small muted">Total Load / Percent</span>
                      <span className={statistic.isOverloaded ? "text-danger" : "text-success"}>
                        <strong>
                          {statistic.totalLoad} kg ({statistic.loadPercent}%)
                        </strong>
                      </span>
                    </h6>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Row>
      )}

      {isEmpty(shippedOrders) && shippedOrders.length < 1 ? (
        <Row className="section-row mb-4 no-records">
          <h4 className="p-0">{"New Trips Assigned"}</h4>
          <p>{"No orders available at the moment."}</p>
        </Row>
      ) : (
        <Row className="section-row mb-4 no-records px-1">
          {/* Clickable header */}
          <Row
            className="mx-0 mb-2"
            style={{
              cursor: "pointer",
              borderBottom: "1px solid #ddd",
              padding: "0.5rem 0",
            }}
            onClick={() => setIsOrderOpen(!isOrderOpen)}
          >
            <Col xs="auto" className="flex-grow-1">
              <h4 className="m-0">New Trips Assigned</h4>
            </Col>
            <Col xs="auto">
              <i
                className={`bi ${isOrderOpen ? "bi-dash-lg" : "bi-plus-lg"}`}
                style={{ fontSize: "1.2rem" }}
              ></i>
            </Col>
          </Row>

          {/* Collapsible content */}
          <Collapse in={isOrderOpen}>
            <div>
              <Row className="mb-0">
                <CustomTable
                  enableRowActions
                  data={shippedOrders}
                  enableTopToolbar={false}
                  enableBottomToolbar={true}
                  enablePagination={true}
                  enableFilters={false}
                  positionActionsColumn={"last"}
                  emptyTableMsg={`No new orders available at the moment.`}
                  columns={tableStructures.new_trips_lp}
                  initialState={{
                    columnPinning: {
                      right: ["mrt-row-actions"],
                    },
                    sorting: [
                      { id: "order_date", desc: true }, // default sort by order_date DESC
                    ],
                  }}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Row style={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}>
                      <h4>{"New Trips Assigned"}</h4>
                    </Row>
                  )}
                  muiTableBodyRowProps={({ row }) => {
                    const { status, shipped_at } = row.original;

                    const todayDate = moment().tz("Asia/Kolkata").format("YYYY-MM-DD");

                    const shippedDate = shipped_at
                      ? moment(shipped_at).tz("Asia/Kolkata").format("YYYY-MM-DD")
                      : null;

                    let highlight = false;
                    if (status === "shipped" && shippedDate === todayDate) {
                      highlight = true;
                    }

                    return {
                      sx: {
                        backgroundColor: highlight ? "#e6ffe6 !important" : "inherit",
                        "& td": {
                          backgroundColor: highlight ? "#e6ffe6 !important" : "inherit",
                        },
                        "&:hover td": {
                          backgroundColor: highlight ? "#d4fcd4 !important" : "rgba(0, 0, 0, 0.04)", // MUI default hover
                        },
                      },
                    };
                  }}
                  renderRowActions={({ row, table }) => (
                    <div className="table-action-box">
                      <CustomButton
                        buttonClasses="action-button accept"
                        id={row.original.id}
                        onClick={() => {
                          // Logic to view order details can be added here
                          setCurrentOrderId(row.original.id);
                          orderViewToggle();
                        }}
                      >
                        {"Accept"}
                      </CustomButton>
                    </div>
                  )}
                />
              </Row>
            </div>
          </Collapse>
        </Row>
      )}

      {isEmpty(lpAcceptedOrders) && lpAcceptedOrders.length < 1 ? (
        <Row className="section-row mb-4 no-records">
          <h4 className="p-0">{"Accepted Trips"}</h4>
          <p>{"No accepted trips at the moment."}</p>
        </Row>
      ) : (
        <Row className="section-row mb-4 no-records px-1">
          {/* Clickable header */}
          <Row
            className="mx-0 mb-2"
            style={{
              cursor: "pointer",
              borderBottom: "1px solid #ddd",
              padding: "0.5rem 0",
            }}
            onClick={() => setIsLPAcceptedOpen(!isLPAcceptedOpen)}
          >
            <Col xs="auto" className="flex-grow-1">
              <h4 className="m-0">Accepted Trips</h4>
            </Col>
            <Col xs="auto">
              <i
                className={`bi ${isLPAcceptedOpen ? "bi-dash-lg" : "bi-plus-lg"}`}
                style={{ fontSize: "1.2rem" }}
              ></i>
            </Col>
          </Row>

          {/* Collapsible content */}
          <Collapse in={isLPAcceptedOpen}>
            <div>
              <Row className="mb-0">
                <CustomTable
                  enableRowActions
                  data={lpAcceptedOrders}
                  enableTopToolbar={false}
                  enableBottomToolbar={true}
                  enablePagination={true}
                  enableFilters={false}
                  positionActionsColumn={"last"}
                  emptyTableMsg={`No accepted trips at the moment.`}
                  columns={tableStructures.lp_accepted_trips}
                  initialState={{
                    columnPinning: {
                      right: ["mrt-row-actions"],
                    },
                    sorting: [
                      { id: "lp_accepted_at", desc: true }, // default sort by shipped_at DESC
                    ],
                  }}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Row style={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}>
                      <h4>{"Accepted Trips"}</h4>
                    </Row>
                  )}
                  muiTableBodyRowProps={({ row }) => {
                    const { status, lp_accepted_at } = row.original;
                    const todayDate = moment().tz("Asia/Kolkata").format("YYYY-MM-DD");
                    const lpAcceptedDate = lp_accepted_at
                      ? moment(lp_accepted_at).tz("Asia/Kolkata").format("YYYY-MM-DD")
                      : null;

                    let highlight = false;
                    if (status === "lpaccepted" && lpAcceptedDate === todayDate) {
                      highlight = true;
                    }

                    return {
                      sx: {
                        backgroundColor: highlight ? "#e6ffe6 !important" : "inherit",
                        "& td": {
                          backgroundColor: highlight ? "#e6ffe6 !important" : "inherit",
                        },
                        "&:hover td": {
                          backgroundColor: highlight ? "#d4fcd4 !important" : "rgba(0, 0, 0, 0.04)", // MUI default hover
                        },
                      },
                    };
                  }}
                  renderRowActions={({ row, table }) => (
                    <div className="table-action-box">
                      <CustomButton
                        buttonClasses="action-button accept"
                        id={row.original.id}
                        onClick={() => {
                          // Logic to view order details can be added here
                          setCurrentOrderId(row.original.id);
                          orderViewToggle();
                        }}
                      >
                        <span className="fw-bolder">
                          <i className="bi bi-eye-fill icon-lg"></i>
                        </span>
                      </CustomButton>
                    </div>
                  )}
                />
              </Row>
            </div>
          </Collapse>
        </Row>
      )}

      {isEmpty(outForDeliveryOrders) && outForDeliveryOrders.length < 1 ? (
        <Row className="section-row mb-4 no-records">
          <h4 className="p-0">{"Out For Delivery Orders"}</h4>
          <p>{"No orders available at the moment."}</p>
        </Row>
      ) : (
        <Row className="section-row mb-4 no-records px-1">
          {/* Clickable header */}
          <Row
            className="mx-0 mb-2"
            style={{
              cursor: "pointer",
              borderBottom: "1px solid #ddd",
              padding: "0.5rem 0",
            }}
            onClick={() => setIsOutForDeliveryOpen(!isOutForDeliveryOpen)}
          >
            <Col xs="auto" className="flex-grow-1">
              <h4 className="m-0">Out For Delivery Orders</h4>
            </Col>
            <Col xs="auto">
              <i
                className={`bi ${isOutForDeliveryOpen ? "bi-dash-lg" : "bi-plus-lg"}`}
                style={{ fontSize: "1.2rem" }}
              ></i>
            </Col>
          </Row>

          {/* Collapsible content */}
          <Collapse in={isOutForDeliveryOpen}>
            <div>
              {Object.entries(outForDeliveryOrdersVehicleWise || {}).map(
                ([vehicleNo, vehicleOrders]) => (
                  <Row key={vehicleNo} className="mb-4">
                    {/* Vehicle sub-header */}
                    <Col xs={12} className="mt-2 text-start">
                      <h5 className="m-0 text-primary d-flex align-items-center">
                        🚚 Vehicle: {vehicleNo}
                        <span className="ms-2 text-muted">({vehicleOrders.length} orders)</span>
                      </h5>
                      <hr className="mt-1 mb-2" />
                    </Col>

                    {/* Vehicle-specific table */}
                    <Col xs={12}>
                      <CustomTable
                        enableRowActions
                        data={vehicleOrders}
                        enableTopToolbar={false}
                        enableBottomToolbar={true}
                        enablePagination={true}
                        enableFilters={false}
                        positionActionsColumn="last"
                        emptyTableMsg="No orders available."
                        columns={tableStructures.lp_outForDelivery_trips}
                        initialState={{
                          columnPinning: {
                            right: ["mrt-row-actions"],
                          },
                          sorting: [{ id: "outfordelivery_at", desc: true }],
                        }}
                        muiTableBodyRowProps={({ row }) => {
                          const { status, outfordelivery_at } = row.original;
                          const today = moment().tz("Asia/Kolkata").format("YYYY-MM-DD");

                          const ofdDate = outfordelivery_at
                            ? moment(outfordelivery_at).tz("Asia/Kolkata").format("YYYY-MM-DD")
                            : null;

                          const highlight = status === "outfordelivery" && ofdDate === today;

                          return {
                            sx: {
                              backgroundColor: highlight ? "#e6ffe6 !important" : "inherit",
                              "& td": {
                                backgroundColor: highlight ? "#e6ffe6 !important" : "inherit",
                              },
                              "&:hover td": {
                                backgroundColor: highlight
                                  ? "#d4fcd4 !important"
                                  : "rgba(0, 0, 0, 0.04)",
                              },
                            },
                          };
                        }}
                        renderRowActions={({ row }) => (
                          <div className="table-action-box">
                            <CustomButton
                              buttonClasses="action-button accept"
                              onClick={() => {
                                setCurrentOrderId(row.original.id);
                                orderViewToggle();
                              }}
                            >
                              Delivered
                            </CustomButton>
                          </div>
                        )}
                      />
                    </Col>
                  </Row>
                ),
              )}
            </div>
          </Collapse>
        </Row>
      )}

      {isEmpty(deliveredOrders) && deliveredOrders.length < 1 ? (
        <Row className="section-row mb-4 no-records">
          <h4 className="p-0">{"Delivered Orders"}</h4>
          <p>{"No orders available at the moment."}</p>
        </Row>
      ) : (
        <Row className="section-row mb-4 no-records px-1">
          {/* Clickable header */}
          <Row
            className="mx-0 mb-2"
            style={{
              cursor: "pointer",
              borderBottom: "1px solid #ddd",
              padding: "0.5rem 0",
            }}
            onClick={() => setIsDeliveredOpen(!isDeliveredOpen)}
          >
            <Col xs="auto" className="flex-grow-1">
              <h4 className="m-0">Delivered Orders</h4>
            </Col>
            <Col xs="auto">
              <i
                className={`bi ${isDeliveredOpen ? "bi-dash-lg" : "bi-plus-lg"}`}
                style={{ fontSize: "1.2rem" }}
              ></i>
            </Col>
          </Row>

          {/* Collapsible content */}
          <Collapse in={isDeliveredOpen}>
            <div>
              {Object.entries(deliveredOrdersVehicleWise || {}).map(
                ([vehicleNo, vehicleOrders]) => (
                  <Row key={vehicleNo} className="mb-4">
                    {/* Vehicle sub-header */}
                    <Col xs={12} className="mt-2 text-start">
                      <h5 className="m-0 text-primary d-flex align-items-center">
                        🚚 Vehicle: {vehicleNo}
                        <span className="ms-2 text-muted">({vehicleOrders.length} orders)</span>
                      </h5>
                      <hr className="mt-1 mb-2" />
                    </Col>

                    {/* Vehicle-specific table */}
                    <Col xs={12}>
                      <CustomTable
                        enableRowActions
                        data={vehicleOrders}
                        enableTopToolbar={false}
                        enableBottomToolbar={true}
                        enablePagination={true}
                        enableFilters={false}
                        positionActionsColumn="last"
                        emptyTableMsg="No orders available at the moment."
                        columns={tableStructures.lp_delivered_trips}
                        initialState={{
                          columnPinning: {
                            right: ["mrt-row-actions"],
                          },
                          sorting: [{ id: "delivered_at", desc: true }],
                        }}
                        muiTableBodyRowProps={({ row }) => {
                          const { status, delivered_at } = row.original;
                          const todayDate = moment().tz("Asia/Kolkata").format("YYYY-MM-DD");

                          const deliveredDate = delivered_at
                            ? moment(delivered_at).tz("Asia/Kolkata").format("YYYY-MM-DD")
                            : null;

                          const highlight = status === "delivered" && deliveredDate === todayDate;

                          return {
                            sx: {
                              backgroundColor: highlight ? "#e6ffe6 !important" : "inherit",
                              "& td": {
                                backgroundColor: highlight ? "#e6ffe6 !important" : "inherit",
                              },
                              "&:hover td": {
                                backgroundColor: highlight
                                  ? "#d4fcd4 !important"
                                  : "rgba(0, 0, 0, 0.04)",
                              },
                            },
                          };
                        }}
                        renderRowActions={({ row }) => (
                          <div className="table-action-box">
                            <CustomButton
                              buttonClasses="action-button accept"
                              onClick={() => {
                                setCurrentOrderId(row.original.id);
                                orderViewToggle();
                              }}
                            >
                              <span className="fw-bolder">
                                <i className="bi bi-eye-fill icon-lg"></i>
                              </span>
                            </CustomButton>
                          </div>
                        )}
                      />
                    </Col>
                  </Row>
                ),
              )}
            </div>
          </Collapse>
        </Row>
      )}
    </Container>
  );
};

export default Dashboard;
